import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { requestOTP, clearPortalError } from '../../redux/reducers/portalAuthSlice';
import { LuMail } from "react-icons/lu";

const PortalLogin = () => {
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, error, otpSent, portalToken, customer } = useSelector((state) => state.portalAuth);

    useEffect(() => {
        if (portalToken && customer?.businessId) {
            navigate(`/customer-side/${customer.businessId}/dashboard`);
        }
        dispatch(clearPortalError());
    }, [portalToken, customer, navigate, dispatch]);

    useEffect(() => {
        if (otpSent) {
            navigate('/customer-side/verify', { state: { email } });
        }
    }, [otpSent, navigate, email]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(requestOTP(email));
    };

    return (
        <div className="bg-light min-vh-100 d-flex align-items-center">
            <Container>
                <div className="text-center mb-4">
                    <div className="d-inline-flex align-items-center gap-2 mb-2">
                        <div className="rounded-2" style={{ width: 4, height: 32, background: "#28B0C4" }} />
                        <h2 className="fw-bold text-dark mb-0">Customer Portal</h2>
                    </div>
                    <p className="text-muted">Enter your email to access your ordering portal</p>
                </div>

                <Card className="border-0 shadow-sm rounded-4 mx-auto" style={{ maxWidth: '400px' }}>
                    <Card.Body className="p-4 p-md-5">
                        {error && <Alert variant="danger" className="rounded-3 small">{error}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-semibold small text-dark">Email Address</Form.Label>
                                <div className="position-relative">
                                    <LuMail className="position-absolute top-50 translate-middle-y ms-3 text-muted" size={18} />
                                    <Form.Control
                                        type="email"
                                        placeholder="name@example.com"
                                        className="rounded-3 py-2 ps-5"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>
                            </Form.Group>

                            <Button
                                type="submit"
                                className="w-100 rounded-3 py-2 fw-bold text-white border-0"
                                style={{ background: "#28B0C4" }}
                                disabled={loading}
                            >
                                {loading ? <Spinner animation="border" size="sm" /> : 'Send Login Code'}
                            </Button>
                        </Form>

                        <div className="mt-4 text-center">
                            <p className="text-muted small mb-0">
                                Don't have access? <br />
                                <span className="text-dark fw-semibold">Contact the business to receive an invite.</span>
                            </p>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default PortalLogin;
